import {makeStyles, Theme} from '@material-ui/core';
import {GRAY, LIGHT_GRAY} from '../../../const/colors';

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        gap: 16
    },
    button: {
        flex: '0 1 200px',
        width: '100%',
        maxWidth: 200,
        minWidth: 0,
        background: 'white',
        border: `1px solid ${LIGHT_GRAY}`,
        color: GRAY,
        textTransform: 'none',
        borderRadius: theme.shape.borderRadius,
        height: 40
    },
    selectedButton: {
        borderColor: theme.palette.secondary.main,
        color: theme.palette.secondary.main,
    },
    [theme.breakpoints.down('md')]: {
        container: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        button: {
            flex: '1',
            maxWidth: '100%',
            height: 40
        },
    }
}));

export default useStyles;
